enum InputType {
    Radio = "radio",
    Checkbox = "checkbox"
}

export default InputType;